import axios from "axios";

export const ACTING_ORGANIZATION_HEADER = "X-Acting-Organization-Public-Id";
const STORAGE_KEY = "gito-acting-organization-public-id";

export function getActingOrganizationPublicId() {
    return localStorage.getItem(STORAGE_KEY) || "";
}

export function setActingOrganizationPublicId(organizationPublicId) {
    if (!organizationPublicId) {
        localStorage.removeItem(STORAGE_KEY);
        return;
    }

    localStorage.setItem(STORAGE_KEY, organizationPublicId);
}

export function clearActingOrganizationPublicId() {
    localStorage.removeItem(STORAGE_KEY);
}

axios.interceptors.request.use((config) => {
    const organizationPublicId = getActingOrganizationPublicId();
    if (organizationPublicId) {
        config.headers[ACTING_ORGANIZATION_HEADER] = organizationPublicId;
    }

    return config;
});
